function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Error when a module class is unavailable
 */
var UnavailableError = function (_Error) {
	_inherits(UnavailableError, _Error);

	/**
  * Creates an UnavailableError
  * @param {string} moduleName Name of the module.
  * @param {Error|string} internalError Internal error as to why the module is unavailable.
  */
	function UnavailableError(moduleName, internalError) {
		_classCallCheck(this, UnavailableError);

		var _this = _possibleConstructorReturn(this, (UnavailableError.__proto__ || Object.getPrototypeOf(UnavailableError)).call(this));

		_this.moduleName = moduleName;
		_this.name = 'UnavailableError';
		_this.internalError = internalError;
		_this.message = 'Module ' + moduleName + ' is unavailable: ' + (internalError.message || internalError);
		return _this;
	}

	return UnavailableError;
}(Error);

export default UnavailableError;